import { render, staticRenderFns } from "./GenericDialog.vue?vue&type=template&id=33f8462e"
import script from "./GenericDialog.vue?vue&type=script&lang=ts"
export * from "./GenericDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports